import {
  SourcingService,
  type VonqPostingRequirementAutocompleteResponse,
} from 'api-clients/monolith';

import type { PostingRequirementsDef } from './requirements-key';

export async function fetchAutocompleteOptions(
  def: PostingRequirementsDef,
  fieldName: string,
  body: Parameters<
    typeof SourcingService.postInternalApiSourcingVonqContractsPostingRequirementsAutocomplete
  >[2],
): Promise<VonqPostingRequirementAutocompleteResponse> {
  if (def.source === 'product') {
    return SourcingService.postInternalApiSourcingVonqProductsPostingRequirementsAutocomplete(
      def.sourceId,
      fieldName,
      // The body passes through as sent: `{}` on lazy load, an array term for
      // a multi-dependency facet.
      body,
    );
  }
  return SourcingService.postInternalApiSourcingVonqContractsPostingRequirementsAutocomplete(
    def.sourceId,
    fieldName,
    body,
  );
}
